<!--suppress CssUnusedSymbol -->
<template>
    <v-footer class="pa-3">
        <v-spacer />
        <v-avatar
            class="mr-1"
            size="20px"
            tile
        >
            <v-img
                :src="ecsArrow"
                contain
            />
        </v-avatar>
        <div class="caption mr-1">
            {{ appVersion }}
        </div>
        <div class="caption">&copy; {{ new Date().getFullYear() }} The ECS Group</div>
    </v-footer>
</template>
<script>
    import {mapGetters} from "vuex";

    export default {
        name: "TheFooter",

        data: () => ({
            ecsArrow: require('@/assets/ecs-arrow.png')
        }),
        computed: {
            ...mapGetters(
            [
                "appVersion",
            ],
            )
        }
    }
</script>

<style scoped>
</style>
